import PropTypes from 'prop-types'
import './ApprovalStatusBadge.css'

/**
 * ApprovalStatusBadge Component
 *
 * Displays a color-coded badge for project approval status
 *
 * @param {string} status - The approval status
 * @param {string} size - Badge size (small, medium, large)
 */
const ApprovalStatusBadge = ({ status, size = 'medium' }) => {
  const statusConfig = {
    // Project approval statuses
    draft: {
      label: 'Draft',
      variant: 'secondary',
      icon: '📝',
    },
    pending_pm_review: {
      label: 'Pending PM Review',
      variant: 'warning',
      icon: '⏳',
    },
    pm_accepted: {
      label: 'PM Accepted',
      variant: 'success',
      icon: '✓',
    },
    pending_executive_review: {
      label: 'Pending Executive Review',
      variant: 'info',
      icon: '👔',
    },
    executive_accepted: {
      label: 'Executive Accepted',
      variant: 'success',
      icon: '✓',
    },
    active: {
      label: 'Active',
      variant: 'success',
      icon: '✅',
    },
    // Checklist approval statuses (from PM review)
    pending: {
      label: 'Pending',
      variant: 'secondary',
      icon: '⏳',
    },
    accepted: {
      label: 'Accepted',
      variant: 'success',
      icon: '✓',
    },
    excused: {
      label: 'Excused',
      variant: 'warning',
      icon: '⚠',
    },
    kept: {
      label: 'Kept',
      variant: 'info',
      icon: '📌',
    },
    rejected: {
      label: 'Rejected',
      variant: 'danger',
      icon: '✗',
    },
  }

  const config = statusConfig[status] || {
    label: status,
    variant: 'secondary',
    icon: '',
  }

  return (
    <span className={`approval-badge approval-badge--${config.variant} approval-badge--${size}`}>
      {config.icon && <span className="approval-badge__icon">{config.icon}</span>}
      <span className="approval-badge__label">{config.label}</span>
    </span>
  )
}

ApprovalStatusBadge.propTypes = {
  status: PropTypes.oneOf([
    // Project approval statuses
    'draft',
    'pending_pm_review',
    'pm_accepted',
    'pending_executive_review',
    'executive_accepted',
    'active',
    // Checklist approval statuses
    'pending',
    'accepted',
    'excused',
    'kept',
    'rejected',
  ]).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
}

export default ApprovalStatusBadge
